const getLocalDate = (date = new Date(), timeZone = 'Europe/Bucharest') => (
  new Date((typeof date === 'string' ? new Date(date) : date)
    .toLocaleString('en-US', { timeZone })));

export default getLocalDate;
